import { ElementRef, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { finalize } from 'rxjs/operators';
import Sortable from 'sortablejs';
import { addFundChartCalcs } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/calcs/calcs.actions';
import { getChartOptions } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-options/chart-options.selectors';
import { addFundChartSecurities, removeFundChartSecurity, setFundChartSecurities, toggleFundChartSecurity, updateFundChartSecurityOrdering, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securities/securities.actions';
import { loadingSecurities, partitionSecuritiesAndLists, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securities/securities.selectors';
import { FundChartSeriesType } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { SecurityListMenuService } from 'SecurityListsApp/ts/services/security-list-menu.service';
import { AddButtonAutocompleteComponent } from 'SearchApp/ts/features/add-button-autocomplete/add-button-autocomplete.component';
import equal from 'NewAngular/utils/equal/deep-equal';
import { disablePointerEvents, enablePointerEvents } from 'NewAngular/utils/sortable-utils';
import { addSecuritiesInfo } from 'SecuritiesApp/ts/state/securities-info/securities-info.actions';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "NewAngular/services/core/ajax.service";
import * as i3 from "SecuritiesApp/ts/services/securities.service";
import * as i4 from "SecurityListsApp/ts/services/security-list-menu.service";
import * as i5 from "@ngrx/store";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i9 from "../../../../../../../../search/static/search/ts/features/multi-item-autocomplete/components/multi-item-autocomplete.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/skeleton-loaders-list/skeleton-loaders-list.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["sortableSecuritiesContainer"];
function FundChartSecuritiesListComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function FundChartSecuritiesListComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-skeleton-loaders-list", 13);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r2.isLoadingSecurities)("numOfSkeletonLoaders", ctx_r2.securities.length);
} }
function FundChartSecuritiesListComponent_ng_template_15_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16)(2, "div", 17)(3, "label", 18)(4, "input", 19);
    i0.ɵɵlistener("click", function FundChartSecuritiesListComponent_ng_template_15_div_0_Template_input_click_4_listener() { const security_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.toggleChartSecurities(security_r5)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 20);
    i0.ɵɵelementStart(6, "span", 21);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 22)(9, "div", 23);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "div", 25);
    i0.ɵɵlistener("click", function FundChartSecuritiesListComponent_ng_template_15_div_0_Template_div_click_11_listener() { const security_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.removeChartSecurities(security_r5)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(12, "svg", 26);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const security_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", i0.ɵɵinterpolate(security_r5.id));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", security_r5.include);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", ctx_r2.securitiesInfo[security_r5.id] == null ? null : ctx_r2.securitiesInfo[security_r5.id].security_name, " (", ctx_r2.securitiesInfo[security_r5.id] == null ? null : ctx_r2.securitiesInfo[security_r5.id].display_security_id, ") ");
} }
function FundChartSecuritiesListComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FundChartSecuritiesListComponent_ng_template_15_div_0_Template, 13, 5, "div", 14);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r2.securities);
} }
/**
 *
 * Fund Chart Securities List Component
 *
 * This component allows users to select securities.
 * It is in the left sidebar on the fund chart page.
 *
 */
export class FundChartSecuritiesListComponent {
    constructor(urlsService, ajaxService, ngZone, securitiesService, securityListMenuService, store) {
        this.urlsService = urlsService;
        this.ajaxService = ajaxService;
        this.ngZone = ngZone;
        this.securitiesService = securitiesService;
        this.securityListMenuService = securityListMenuService;
        this.store = store;
        this.fetchingSecuritiesInfo = false;
        this.hasSecurityLists = true;
        this.isLoadingSecurities = true;
        this.formattedSecurityNames = [];
        this.securities = [];
        // A mapping of security ids to their position in the securities list, relative to other *included* securities.
        // Securities that are not included have a null value for their index.
        // Ex: securities = [{id: 'A', include: false}, {id: 'B', include: true}]. Here, security B is at index 0.
        // This is needed so the customize modal can use the correct default values.
        this.securitiesIncludedIndexMap = {};
        this.securitiesInfo = {};
        this.securityListLabels = null;
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent.bind(this));
    }
    ngOnInit() {
        this.securityListMenuService.getLabels().subscribe((response) => {
            this.securityListLabels = response;
            // Normally we format the security names in mapStateToComponent. Once we get the security
            // list labels we need to explicitly format the names.
            this.formattedSecurityNames = this.securities.map((sec) => this.getSecurityName(sec));
        });
    }
    ngAfterViewInit() {
        this.initializeSortable();
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    mapStateToComponent(state) {
        this.chartOptions = getChartOptions(state);
        this.isLoadingSecurities = !!loadingSecurities(state);
        const { securityLists } = partitionSecuritiesAndLists(state);
        this.hasSecurityLists = securityLists.length > 0;
        this.securities = state.fundChart.securities;
        this.securitiesIncludedIndexMap = this.updateSecuritiesIncludedIndexMap();
        this.securitiesInfo = state.securitiesInfo;
        this.calcs = state.fundChart.calcs;
        this.formattedSecurityNames = this.securities.map((sec) => this.getSecurityName(sec));
        if (this.securities.length > 0) {
            this.validateNextSecurities();
        }
    }
    validateNextSecurities() {
        /**
         * Validates the next set of securities and security lists by doing the following:
         *   1. Remove duplicates
         *   2. If any securities are missing info, fetch their info
         *
         * One thing to keep in mind here is that it needs to preserve the order of securities and lists
         * that were passed in.
         */
        const uniqueSecurities = this.securities.filter((s, idx, arr) => idx === arr.findIndex((_) => _.id === s.id));
        const securitiesMissingInfo = uniqueSecurities.filter((s) => !this.securitiesInfo[s.id]).map((sec) => sec.id);
        if (securitiesMissingInfo.length > 0 && !this.fetchingSecuritiesInfo) {
            this.fetchingSecuritiesInfo = true;
            this.securitiesService
                .getSecuritiesInfo(securitiesMissingInfo.join(','))
                .pipe(finalize(() => {
                const validSecurities = uniqueSecurities.filter((sec) => this.securitiesInfo[sec.id]);
                // Set unique, valid securities regardless of whether the request succeeds
                if (!equal(this.securities, validSecurities)) {
                    this.store.dispatch(setFundChartSecurities({
                        fundChartSecurities: validSecurities,
                    }));
                }
                this.fetchingSecuritiesInfo = false;
            }))
                .subscribe((data) => {
                this.store.dispatch(addSecuritiesInfo({ securitiesInfo: data }));
            });
        }
        else if (securitiesMissingInfo.length === 0) {
            if (!equal(this.securities, uniqueSecurities)) {
                this.store.dispatch(setFundChartSecurities({ fundChartSecurities: uniqueSecurities }));
            }
        }
    }
    getSecurityName(security) {
        const info = this.securitiesInfo[security.id];
        return info ? `${info.security_name} (${security.id})` : '';
    }
    initializeSortable() {
        // For performance reasons we don't want Angular change detection to run while dragging an
        // element around, so we explicitly run SortableJS outside of Angular.
        this.ngZone.runOutsideAngular(() => {
            Sortable.create(this.sortableSecuritiesContainer.nativeElement, {
                handle: '.btn-reorder-up',
                scroll: false,
                animation: 150,
                onUpdate: (event) => {
                    // Once we're done updating we want to dispatch the NgRx action from inside ngZone again.
                    this.ngZone.run(() => {
                        this.store.dispatch(updateFundChartSecurityOrdering({ oldIndex: event.oldIndex, newIndex: event.newIndex }));
                        // This is a workaround for a bug in the Sortable library which can recheck
                        // unchecked items after dragging. There is no entrypoint provided by SortableJS
                        // after it updates the checkbox state, so we need to delay execution.
                        setTimeout(() => {
                            const { children } = event.target;
                            this.securities.forEach((security) => {
                                for (let i = 0; i < children.length; i += 1) {
                                    const child = children[i];
                                    if (security.id === child.id) {
                                        const el = child.getElementsByClassName('custom-control-input')[0];
                                        if (el.checked !== security.include) {
                                            el.checked = security.include;
                                        }
                                    }
                                }
                            });
                        });
                    });
                },
                onStart: () => {
                    // Prevent pointer-events on btn classes on click in modules-container for tooltip/sortable bug
                    disablePointerEvents(document, 'options-list-item');
                },
                onEnd: () => {
                    enablePointerEvents(document, 'options-list-item');
                },
            });
        });
    }
    /**
     * Update the index of securities relative to other included securities.
     * @return An object mapping security ids to their index relative to other included securities.
     */
    updateSecuritiesIncludedIndexMap() {
        let includedIndex = 0;
        for (let i = 0; i < this.securities.length; i += 1) {
            const security = this.securities[i];
            if (security.include) {
                this.securitiesIncludedIndexMap[security.id] = includedIndex;
                includedIndex += 1;
            }
            else {
                this.securitiesIncludedIndexMap[security.id] = -1;
            }
        }
        return this.securitiesIncludedIndexMap;
    }
    toggleChartSecurities(fundChartSecurity) {
        this.store.dispatch(toggleFundChartSecurity({
            fundChartSecurity,
        }));
    }
    removeChartSecurities(fundChartSecurity) {
        this.store.dispatch(removeFundChartSecurity({
            fundChartSecurity,
        }));
    }
    addMultipleSecurities(securityIds) {
        const uniqueSecurityIds = [...new Set(securityIds)];
        this.ajaxService
            .getDataObserveBody(this.urlsService.CHARTS.FUND_CHART_CALC, {
            newSecurityIDs: uniqueSecurityIds.join(','),
            currentSecurityIDs: this.securities.map((security) => security.id).join(','),
            currentCalcs: this.calcs.map((calc) => calc.id).join(','),
        })
            .subscribe({
            next: (response) => {
                // only dispatch addFundChartCalc if there is a new calc
                if (response.new_calcs.length) {
                    const metrics = response.new_calcs.map((calc) => ({ id: calc, include: true }));
                    this.store.dispatch(addFundChartCalcs({ metrics }));
                }
                const securitiesInfo = response.new_security_info.map((info) => ({
                    id: info.security_id,
                    security_name: info.security_name,
                    feature_needed: info.feature_needed,
                    features_needed: info.features_needed,
                    display_security_id: info.display_security_id,
                    inception_date: info.inception_date,
                }));
                const fundChartSecurities = response.new_security_info.map((info) => ({
                    id: info.security_id,
                    include: true,
                    type: FundChartSeriesType.security,
                }));
                this.store.dispatch(addSecuritiesInfo({ securitiesInfo }));
                this.store.dispatch(addFundChartSecurities({
                    fundChartSecurities,
                    fundChartChartOptions: this.chartOptions,
                }));
            },
        });
    }
    addSecurity(securityResult) {
        this.addMultipleSecurities([securityResult.search_id]);
    }
}
FundChartSecuritiesListComponent.ɵfac = function FundChartSecuritiesListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartSecuritiesListComponent)(i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.AjaxService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i3.SecuritiesService), i0.ɵɵdirectiveInject(i4.SecurityListMenuService), i0.ɵɵdirectiveInject(i5.Store)); };
FundChartSecuritiesListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartSecuritiesListComponent, selectors: [["ycn-fund-chart-securities-list"]], viewQuery: function FundChartSecuritiesListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(AddButtonAutocompleteComponent, 5);
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortableSecuritiesContainer = _t.first);
    } }, standalone: false, decls: 17, vars: 6, consts: [["helpModal", ""], ["sortableSecuritiesContainer", ""], ["skeletonLoadersList", ""], ["securitiesList", ""], [1, "panel-sidebar-section-header"], [1, "panel-sidebar-section-title", "user-select-none"], [1, "help-toggler", 3, "click"], ["name", "securities"], [1, "panel-sidebar-section-row"], ["data-test-id", "securities-search-autocomplete", 1, "input-group", 3, "multiSubmitHandler", "submitHandler", "appendToBody", "searchType", "showMoreResultsUrl"], [1, "panel-sidebar-section-body"], ["id", "securities-list", 1, "options-list", "user-select-none"], [4, "ngIf", "ngIfThen", "ngIfElse"], [3, "loading", "numOfSkeletonLoaders"], ["class", "options-list-item", "data-test-id", "security-list-item", 3, "id", 4, "ngFor", "ngForOf"], ["data-test-id", "security-list-item", 1, "options-list-item", 3, "id"], [1, "options-list-item-header"], [1, "options-list-item-title"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "options-list-item-controls"], ["ycnTooltip", "", "tooltipPlacement", "bottom", "tooltipTitle", "Reorder", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-reorder-up"], ["ycnIcon", "", "name", "icon-reorder-up"], ["ycnTooltip", "", "tooltipTitle", "Remove", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", "name", "icon-close"]], template: function FundChartSecuritiesListComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 4)(1, "div", 5);
        i0.ɵɵtext(2, " Securities ");
        i0.ɵɵelementStart(3, "span", 6);
        i0.ɵɵlistener("click", function FundChartSecuritiesListComponent_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(6); return i0.ɵɵresetView(helpModal_r2.openModal("securities")); });
        i0.ɵɵtext(4, "(?)");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "ycn-help-modal", 7, 0);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 8)(8, "ycn-multi-item-autocomplete", 9);
        i0.ɵɵlistener("multiSubmitHandler", function FundChartSecuritiesListComponent_Template_ycn_multi_item_autocomplete_multiSubmitHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addMultipleSecurities($event)); })("submitHandler", function FundChartSecuritiesListComponent_Template_ycn_multi_item_autocomplete_submitHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addSecurity($event)); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(9, "div", 10)(10, "div", 11, 1);
        i0.ɵɵtemplate(12, FundChartSecuritiesListComponent_ng_container_12_Template, 1, 0, "ng-container", 12)(13, FundChartSecuritiesListComponent_ng_template_13_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(15, FundChartSecuritiesListComponent_ng_template_15_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const skeletonLoadersList_r6 = i0.ɵɵreference(14);
        const securitiesList_r7 = i0.ɵɵreference(16);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("appendToBody", true)("searchType", "main")("showMoreResultsUrl", false);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.isLoadingSecurities || ctx.hasSecurityLists && !ctx.securityListLabels)("ngIfThen", skeletonLoadersList_r6)("ngIfElse", securitiesList_r7);
    } }, dependencies: [i6.NgForOf, i6.NgIf, i7.HelpModalComponent, i8.IconDirective, i9.MultiItemAutocompleteComponent, i10.SkeletonLoadersListComponent, i11.TooltipDirective], encapsulation: 2 });
